var API_DOMAIN = "https://chellamfinance.zentexus.in/api";

export default API_DOMAIN;
